import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import CopyRightInfo from "../../../core/common/copyRightInfo";
import { API } from '../../../common/Constants';
import useFetch from '../../../hooks/useFetch';
import { getAPIHeaders } from '../../../common/Utils';
import PreLoader from '../../../core/common/preLoader';

const AdminDashboard = () => {
  const routes = all_routes;
  const { isLoading, data, status, callFetch } = useFetch();


  useEffect(() => {
    fetch();
  }, []);

  useEffect(() => {
    if (data && status && status >= 200 && status < 299) {
      updateChartData(data);
    }
  }, [data, status]);

  const fetch = () => {
    callFetch(
      API.ADMIN_DASHBORD,
      'GET',
      getAPIHeaders(),
      null,
      null
    ).catch((err) => {});;
  };

  const updateChartData = (dashboardData: any) => {
    if (dashboardData.idleFaculties) {
      const sortedFaculties = dashboardData.idleFaculties
        .sort((a: any, b: any) => a.count - b.count);
      
      const facultyNames = sortedFaculties.map((item: any) => item.name);
      const periodCounts = sortedFaculties.map((item: any) => item.count);
      
      setIdelFacultyTeachingLoadData({
        series: [{
          name: 'Periods',
          data: periodCounts
        }],
        options: {
          ...idelFacultyTeachingLoadData.options,
          xaxis: {
            ...idelFacultyTeachingLoadData.options.xaxis,
            categories: facultyNames
          }
        }
      });
      
    }
    
    // Update Faculty Subjects chart
    if (dashboardData.subjectsByFaculty) {
      const facultyNames = dashboardData.subjectsByFaculty.map((item: any) => item.name);
      const subjectCounts = dashboardData.subjectsByFaculty.map((item: any) => item.count);
      
      setFacultySubjectsData({
        series: [{
          name: 'Subjects',
          data: subjectCounts
        }],
        options: {
          ...facultySubjectsData.options,
          xaxis: {
            ...facultySubjectsData.options.xaxis,
            categories: facultyNames
          }
        }
      });
    }

    // Update Students by Course chart
    if (dashboardData.studentsByCourse) {
      const courseCodes = dashboardData.studentsByCourse.map((item: any) => item.courseCode);
      const studentCounts = dashboardData.studentsByCourse.map((item: any) => item.count);
      
      setStudentsByCourseData({
        series: [{
          name: 'Students',
          data: studentCounts
        }],
        options: {
          ...studentsByCourseData.options,
          xaxis: {
            ...studentsByCourseData.options.xaxis,
            categories: courseCodes
          }
        }
      });
    }

    if (dashboardData.studentsPerformanceByBatch) {
      // Group by batch and organize by performance
      const performanceByBatch: Record<string, Record<string, number>> = {};
      
      dashboardData.studentsPerformanceByBatch.forEach((item: any) => {
        const batch = item.batch;
        const performance = item.performance || 'No Rating';
        
        if (!performanceByBatch[batch]) {
          performanceByBatch[batch] = {};
        }
        
        performanceByBatch[batch][performance] = item.count;
      });
      
      const batches = Object.keys(performanceByBatch);
      const excellentCounts = batches.map(batch => performanceByBatch[batch]['EXCELLENT'] || 0);
      const needsImprovementCounts = batches.map(batch => performanceByBatch[batch]['NEEDS IMPROVEMENT'] || 0);
      const noRatingCounts = batches.map(batch => performanceByBatch[batch]['No Rating'] || 0);
      
      setStudentPerformanceData({
        series: [
          {
            name: 'EXCELLENT',
            data: excellentCounts
          },
          {
            name: 'NEEDS IMPROVEMENT',
            data: needsImprovementCounts
          },
          {
            name: 'No Rating',
            data: noRatingCounts
          }
        ],
        options: {
          ...studentPerformanceData.options,
          xaxis: {
            ...studentPerformanceData.options.xaxis,
            categories: batches
          }
        }
      });
    }

    // Update Employees by Designation chart
    if (dashboardData.emoployessByDesignation) {
      const designations = dashboardData.emoployessByDesignation.map((item: any) => item.name);
      const designationCounts = dashboardData.emoployessByDesignation.map((item: any) => item.count);
      const totalEmployees = designationCounts.reduce((sum: number, count: number) => sum + count, 0);
      
      setEmployeesByDesignationData({
        series: designationCounts,
        options: {
          ...employeesByDesignationData.options,
          labels: designations,
          plotOptions: {
            ...employeesByDesignationData.options.plotOptions,
            pie: {
              ...employeesByDesignationData.options.plotOptions.pie,
              donut: {
                ...employeesByDesignationData.options.plotOptions.pie.donut,
                labels: {
                  ...employeesByDesignationData.options.plotOptions.pie.donut.labels,
                  total: {
                    ...employeesByDesignationData.options.plotOptions.pie.donut.labels.total,
                    formatter: function() {
                      return totalEmployees.toString();
                    }
                  }
                }
              }
            }
          }
        }
      });
    }

    // Update Students by Batch chart
    if (dashboardData.studentsByBatch) {
      const batches = dashboardData.studentsByBatch.map((item: any) => item.batch);
      const batchCounts = dashboardData.studentsByBatch.map((item: any) => item.count);
      const totalStudents = batchCounts.reduce((sum: number, count: number) => sum + count, 0);
      
      setStudentsByBatchData({
        series: batchCounts,
        options: {
          ...studentsByBatchData.options,
          labels: batches,
          plotOptions: {
            ...studentsByBatchData.options.plotOptions,
            pie: {
              ...studentsByBatchData.options.plotOptions.pie,
              donut: {
                ...studentsByBatchData.options.plotOptions.pie.donut,
                labels: {
                  ...studentsByBatchData.options.plotOptions.pie.donut.labels,
                  total: {
                    ...studentsByBatchData.options.plotOptions.pie.donut.labels.total,
                    formatter: function() {
                      return totalStudents.toString();
                    }
                  }
                }
              }
            }
          }
        }
      });
    }

    // Update Employees by Department chart
    if (dashboardData.emoployessByDepartment) {
      const departments = dashboardData.emoployessByDepartment.map((item: any) => item.name);
      const departmentCounts = dashboardData.emoployessByDepartment.map((item: any) => item.count);
      const totalDeptEmployees = departmentCounts.reduce((sum: number, count: number) => sum + count, 0);
      
      setEmployeesByDepartmentData({
        series: departmentCounts,
        options: {
          ...employeesByDepartmentData.options,
          labels: departments,
          plotOptions: {
            ...employeesByDepartmentData.options.plotOptions,
            pie: {
              ...employeesByDepartmentData.options.plotOptions.pie,
              donut: {
                ...employeesByDepartmentData.options.plotOptions.pie.donut,
                labels: {
                  ...employeesByDepartmentData.options.plotOptions.pie.donut.labels,
                  total: {
                    ...employeesByDepartmentData.options.plotOptions.pie.donut.labels.total,
                    formatter: function() {
                      return totalDeptEmployees.toString();
                    }
                  }
                }
              }
            }
          }
        }
      });
    }

    // Update Faculty Teaching Load chart
    if (dashboardData.facultyTeachingLoad) {
      const facultyNames = dashboardData.facultyTeachingLoad.map((item: any) => item.name);
      const periodCounts = dashboardData.facultyTeachingLoad.map((item: any) => item.count);
      
      setFacultyTeachingLoadData({
        series: [{
          name: 'Periods',
          data: periodCounts
        }],
        options: {
          ...facultyTeachingLoadData.options,
          xaxis: {
            ...facultyTeachingLoadData.options.xaxis,
            categories: facultyNames
          }
        }
      });
    }
  };

  // Faculty subjects data
  const [facultySubjectsData, setFacultySubjectsData] = useState<any>({
    series: [{
      name: 'Subjects',
      data: []
    }],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            position: 'top',
          },
          barHeight: '70%',
          borderRadius: 4
        },
      },
      colors: ['#F26522'],
      dataLabels: {
        enabled: true,
        offsetX: -6,
        style: {
          fontSize: '12px',
          colors: ['#fff']
        }
      },
      stroke: {
        show: true,
        width: 1,
        colors: ['#fff']
      },
      grid: {
        borderColor: '#E5E7EB',
        strokeDashArray: 5,
      },
      xaxis: {
        categories: [],
        title: {
          text: 'Number of Subjects',
        }
      },
      yaxis: {
        title: {
          text: 'Faculty Members',
        },
      },
      tooltip: {
        y: {
          title: {
            formatter: function() {
              return 'Subjects:';
            }
          }
        }
      }
    }
  });

  // Student count by course data
  const [studentsByCourseData, setStudentsByCourseData] = useState<any>({
    series: [{
      name: 'Students',
      data: []
    }],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            position: 'top',
          },
          barHeight: '70%',
          borderRadius: 4,
          distributed: false
        },
      },
      colors: ['#03C95A'],
      dataLabels: {
        enabled: true,
        offsetX: -6,
        style: {
          fontSize: '12px',
          colors: ['#fff']
        }
      },
      stroke: {
        show: true,
        width: 1,
        colors: ['#fff']
      },
      grid: {
        borderColor: '#E5E7EB',
        strokeDashArray: 5,
      },
      xaxis: {
        categories: [],
        title: {
          text: 'Number of Students',
        }
      },
      yaxis: {
        title: {
          text: 'Course Code',
        },
      },
      tooltip: {
        y: {
          title: {
            formatter: function() {
              return 'Students:';
            }
          }
        }
      }
    }
  });

  // Student performance by batch data
  const [studentPerformanceData, setStudentPerformanceData] = useState<any>({
    series: [
      {
        name: 'EXCELLENT',
        data: []
      },
      {
        name: 'NEEDS IMPROVEMENT',
        data: []
      },
      {
        name: 'No Rating',
        data: []
      }
    ],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        stacked: true,
        stackType: '100%',
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          borderRadius: 5,
          borderRadiusWhenStacked: 'last',
          dataLabels: {
            total: {
              enabled: true,
              style: {
                fontSize: '13px',
                fontWeight: 900
              }
            }
          }
        },
      },
      colors: ['#03C95A', '#E70D0D', '#6B7280'],
      dataLabels: {
        enabled: true,
        formatter: function(val: any) {
          return val.toFixed(2);
        },
        style: {
          fontSize: '12px',
          colors: ['#fff']
        },
      },
      stroke: {
        width: 1,
        colors: ['#fff']
      },
      grid: {
        borderColor: '#E5E7EB',
        strokeDashArray: 5,
      },
      xaxis: {
        categories: [],
        labels: {
          style: {
            fontSize: '13px',
          }
        }
      },
      yaxis: {
        title: {
          text: 'Number of Students',
        },
        labels: {
          formatter: function(val: number) {
            return val.toFixed(0);
          }
        }
      },
      tooltip: {
        y: {
          formatter: function(val: any) {
            return val + " students";
          }
        }
      },
      fill: {
        opacity: 1
      },
      legend: {
        position: 'top',
        horizontalAlign: 'center',
        offsetY: 10
      }
    }
  });

  // Employee count by designation data
  const [employeesByDesignationData, setEmployeesByDesignationData] = useState<any>({
    series: [],
    options: {
      chart: {
        type: 'donut',
        height: 350
      },
      labels: [],
      colors: [
        '#1B84FF', '#F26522', '#03C95A', '#FFC107', '#8B5CF6', 
        '#E70D0D', '#0C4B5E', '#EC4899', '#14B8A6', '#6B7280'
      ],
      plotOptions: {
        pie: {
          donut: {
            size: '65%',
            labels: {
              show: true,
              name: {
                show: true
              },
              value: {
                show: true,
                formatter: function(val: any) {
                  return val;
                }
              },
              total: {
                show: true,
                label: 'Total',
                formatter: function() {
                  return '0'; // Will be updated dynamically
                }
              }
            }
          }
        }
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        position: 'bottom',
        horizontalAlign: 'center',
        fontSize: '13px'
      },
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            height: 300
          },
          legend: {
            position: 'bottom'
          }
        }
      }],
      tooltip: {
        y: {
          formatter: function(value: any) {
            return value + " employee" + (value > 1 ? "s" : "");
          }
        }
      }
    }
  });

  // Students by batch data - Donut Chart
  const [studentsByBatchData, setStudentsByBatchData] = useState<any>({
    series: [],
    options: {
      chart: {
        type: 'donut',
        height: 350
      },
      labels: [],
      colors: [
        '#F26522', '#1B84FF', '#03C95A', '#FFC107', '#8B5CF6', '#14B8A6'
      ],
      plotOptions: {
        pie: {
          donut: {
            size: '65%',
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: '14px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                fontWeight: 600
              },
              value: {
                show: true,
                fontSize: '14px',
                fontFamily: 'Helvetica, Arial, sans-serif',
                formatter: function(val: any) {
                  return val + " students";
                }
              },
              total: {
                show: true,
                label: 'Total',
                fontSize: '16px',
                fontWeight: 600,
                formatter: function() {
                  return '0'; // Will be updated dynamically
                }
              }
            }
          }
        }
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        position: 'bottom',
        horizontalAlign: 'center',
        fontSize: '13px'
      },
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            height: 300
          },
          legend: {
            position: 'bottom'
          }
        }
      }],
      tooltip: {
        y: {
          formatter: function(value: any) {
            return value + " student" + (value > 1 ? "s" : "");
          }
        }
      }
    }
  });

  // Employees by department data - Donut Chart
  const [employeesByDepartmentData, setEmployeesByDepartmentData] = useState<any>({
    series: [],
    options: {
      chart: {
        type: 'donut',
        height: 350
      },
      labels: [],
      colors: [
        '#E70D0D', '#1B84FF', '#F26522', '#03C95A', '#8B5CF6',
        '#FFC107', '#EC4899', '#14B8A6', '#6B7280', '#0C4B5E'
      ],
      plotOptions: {
        pie: {
          donut: {
            size: '65%',
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: '14px',
                fontWeight: 600
              },
              value: {
                show: true,
                fontSize: '14px',
                formatter: function(val: any) {
                  return val + " employees";
                }
              },
              total: {
                show: true,
                label: 'Total',
                fontSize: '16px',
                fontWeight: 600,
                formatter: function() {
                  return '0'; // Will be updated dynamically
                }
              }
            }
          }
        }
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        position: 'bottom',
        horizontalAlign: 'center',
        fontSize: '13px',
        markers: {
          width: 12,
          height: 12,
          radius: 6
        },
        itemMargin: {
          horizontal: 6,
          vertical: 3
        }
      },
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            height: 300
          },
          legend: {
            position: 'bottom'
          }
        }
      }],
      tooltip: {
        y: {
          formatter: function(value: any) {
            return value + " employee" + (value > 1 ? "s" : "");
          }
        }
      }
    }
  });

  // Faculty teaching load data - Horizontal Bar Chart
  const [facultyTeachingLoadData, setFacultyTeachingLoadData] = useState<any>({
    series: [{
      name: 'Periods',
      data: []
    }],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            position: 'top',
          },
          barHeight: '70%',
          borderRadius: 4
        },
      },
      colors: ['#1B84FF'],
      dataLabels: {
        enabled: true,
        offsetX: -6,
        style: {
          fontSize: '12px',
          colors: ['#fff']
        }
      },
      stroke: {
        show: true,
        width: 1,
        colors: ['#fff']
      },
      grid: {
        borderColor: '#E5E7EB',
        strokeDashArray: 5,
      },
      xaxis: {
        categories: [],
        title: {
          text: 'Number of Periods',
        }
      },
      yaxis: {
        title: {
          text: 'Faculty Members',
        },
      },
      tooltip: {
        y: {
          title: {
            formatter: function() {
              return 'Periods:';
            }
          }
        }
      }
    }
  });

    // Faculty teaching load data - Horizontal Bar Chart
  const [idelFacultyTeachingLoadData, setIdelFacultyTeachingLoadData] = useState<any>({
    series: [{
      name: 'Periods',
      data: []
    }],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            position: 'top',
          },
          barHeight: '70%',
          borderRadius: 4
        },
      },
      colors: ['#FFC107'],
      dataLabels: {
        enabled: true,
        offsetX: -6,
        style: {
          fontSize: '12px',
          colors: ['#fff']
        }
      },
      stroke: {
        show: true,
        width: 1,
        colors: ['#fff']
      },
      grid: {
        borderColor: '#E5E7EB',
        strokeDashArray: 5,
      },
      xaxis: {
        categories: [],
        title: {
          text: 'Number of Periods',
        }
      },
      yaxis: {
        title: {
          text: 'Faculty Members',
        },
      },
      tooltip: {
        y: {
          title: {
            formatter: function() {
              return 'Periods:';
            }
          }
        }
      }
    }
  });

  return (
    <>
      <PreLoader showLoader={isLoading} />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Admin Dashboard</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Dashboard</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Admin Dashboard
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          
          {/* Charts Row */}
          <div className="row">
            <div className="col-lg-6">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Teaching Assignment per Faculty (Periods)</h4>
                </div>
                <div className="card-body">
                  <div id="faculty-teaching-load-chart">
                    <ReactApexChart 
                      options={facultyTeachingLoadData.options}
                      series={facultyTeachingLoadData.series}
                      type="bar"
                      height={350}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Faculty with Light Teaching load (Periods)</h4>
                </div>
                <div className="card-body">
                  <div id="faculty-teaching-load-chart">
                    <ReactApexChart 
                      options={idelFacultyTeachingLoadData.options}
                      series={idelFacultyTeachingLoadData.series}
                      type="bar"
                      height={350}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">

            {/* Students by Batch Chart */}
            <div className="col-lg-6">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Student Enrollment by Batch</h4>
                </div>
                <div className="card-body">
                  <div id="students-by-batch-chart">
                    <ReactApexChart 
                      options={studentsByBatchData.options}
                      series={studentsByBatchData.series}
                      type="donut"
                      height={350}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* /Students by Batch Chart */}
            {/* Students by Course Chart */}
            <div className="col-lg-6">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Student Enrollment by Course</h4>
                </div>
                <div className="card-body">
                  <div id="students-by-course-chart">
                    <ReactApexChart 
                      options={studentsByCourseData.options}
                      series={studentsByCourseData.series}
                      type="bar"
                      height={350}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* /Students by Course Chart */}
          </div>
          {/* /Charts Row */}
          
          {/* Student Performance and Employees Row */}
          <div className="row">
            {/* Student Performance Chart */}
            <div className="col-lg-6">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Academic Performance by Batch</h4>
                </div>
                <div className="card-body">
                  <div id="student-performance-chart">
                    <ReactApexChart 
                      options={studentPerformanceData.options}
                      series={studentPerformanceData.series}
                      type="bar"
                      height={350}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* /Student Performance Chart */}
            
            {/* Employees by Designation Chart */}
            <div className="col-lg-6">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Employees by Designation</h4>
                </div>
                <div className="card-body">
                  <div id="employees-by-designation-chart">
                    <ReactApexChart 
                      options={employeesByDesignationData.options}
                      series={employeesByDesignationData.series}
                      type="donut"
                      height={350}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* /Employees by Designation Chart */}
          </div>
          {/* /Student Performance and Employees Row */}
          
          {/* Faculty Teaching Load and Students By Batch Row */}
          <div className="row">
            <div className="col-lg-6">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Employees by Department</h4>
                </div>
                <div className="card-body">
                  <div id="employees-by-department-chart">
                    <ReactApexChart 
                      options={employeesByDepartmentData.options}
                      series={employeesByDepartmentData.series}
                      type="donut"
                      height={350}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* Faculty Subjects Chart */}
            <div className="col-lg-6">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Subjects Assigned to Each Faculty</h4>
                </div>
                <div className="card-body">
                  <div id="faculty-subjects-chart">
                    <ReactApexChart 
                      options={facultySubjectsData.options}
                      series={facultySubjectsData.series}
                      type="bar"
                      height={350}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* /Faculty Subjects Chart */}
          </div>
 
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <CopyRightInfo/>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>

  );
};

export default AdminDashboard;
